import React from 'react';
import { useTranslation } from 'react-i18next';

const ReceiverClensingPage = () => {
  const { t } = useTranslation();
  return (
    <div style={{ padding: 20 }}>
      <h2>{t('receiverCleansing')}</h2>
      <div style={{ marginTop: 20 }}>{t('underConstruction')}</div>
    </div>
  );
};

export default ReceiverClensingPage;
